import {
	FormContentSection,
	FormSectionCard,
	FormSectionTitle,
	Select,
	Seperator,
	StyledForm,
	StyledInput,
	StyledTextArea,
	SubmitButton,
	SubmitButtonContainer,
} from '../../Containers/PasserCommande/PasserCommande.styles'
import React, { useEffect, useRef, useState,useMemo } from 'react'
import { useOptimizedComponentWillMount } from '../../hooks'
import RadioGroup from '../RadioGroup'
import {
	nombreEtagesAtom,
	optionsPoidsLourdsAtom,
	optionsVehiculeLegerAtom,
	rippeurHoursAtom,
	rippeursAtom,
	temporisationAtom,
	typeCommandeAtom,
	typeEtageAtom,
	typeTransportAtom,
	dangerAtom,
} from '../../utils/price'
import { useForm, useWatch } from 'react-hook-form'
import vehiculeCamion from '../../assets/img/vehicule_camion.png'
import { CustomInput } from '../../Containers/RegisterTransporter/style'
import InformationCourseACourse from '../../Containers/PasserCommande/InformationsCourseACourse'
import InformationsMiseADispo from '../../Containers/PasserCommande/InformationsMiseADispo'
import PoidsLours from '../../assets/img/poid_lourd@2x.png'
import VehiculeLeger from '../../assets/img/vehicule_leger@2x.png'
import tonnes7 from '../../assets/img/7.5.png'
import tonnes19 from '../../assets/img/tonnes19.png'
import Fourgon14 from '../../assets/img/fourgon12m.png'
import Fourgon12 from '../../assets/img/captureF12.png'
import Break from '../../assets/img/CaptureBreak.png'
import Semi from '../../assets/img/semi.png'
import tonnes12 from '../../assets/img/tonnes12.png'
import tracteurSemi from '../../assets/img/tracteur-actos.png'
import { useAtom } from 'jotai'
import {  useSelector } from 'react-redux'
import PhoneInput from 'react-phone-input-2'
import { Controller } from 'react-hook-form'
import UploadFileCommande from '../UploadFileCommande/UploadFileCommande'
import { Link  } from 'react-router-dom'
import { Info } from 'lucide-react'
import { useTranslation } from 'react-i18next'


function CommandeForm({
	onSubmit,
	onError = () => {},
	loading = false,
	preloadForm = false,
	keepFilesAsObjects = false,
	preloadData,
	hideSubmit = false,
	disabled = false,
	submitButtonText = 'Payer',
	heur,
	setHeur,
	step,
	setStep,
	setIsStepOne,
	isStepOne,
	setPrice,
}) {
	const {
		register,
		handleSubmit,
		watch,
		setValue,
		unregister,
		control,
		reset,
		getValues,
		formState: { errors, isValid, isDirty },
	} = useForm({
		mode: 'onChange',
	})

	const user = useSelector((state) => state.auth.user)
	const missions = useWatch({ control, name: 'missions', defaultValue: [] });

	const type_transport = useRef()
	type_transport.current = watch('type_transport', '')
	const type_commande = useRef()
	type_commande.current = watch('type_commande', '')

	const livraison = useRef()
	livraison.current = watch('livraison', '')
	const nature_chargement = useRef()
	nature_chargement.current = watch(`nature_chargement`, '')

	const assurance = useRef()
	assurance.current = watch('assurance', '')

	const [typeCommande, setTypeCommande] = useAtom(typeCommandeAtom)
	const [typeTransport, setTypeTransport] = useAtom(typeTransportAtom)
	const [temporisation, setTemporisation] = useAtom(temporisationAtom)
	const [typeEtage, setTypeEtage] = useAtom(typeEtageAtom)
	const [danger, setDanger] = useAtom(dangerAtom)
	const [nombreEtages, setNombreEtages] = useAtom(nombreEtagesAtom)
	const [rippeurHours, setRippeurHours] = useAtom(rippeurHoursAtom)
	const [rippeurs, setRippeurs] = useAtom(rippeursAtom)
	const [showTooltip, setShowTooltip] = useState(false)
	const [isEtageDisabled, setIsEtageDisabled] = useState(false)
	const [isBreakDisabled, setIsBreakDisabled] = useState(false)
	const [isF12Disabled, setIsF12Disabled] = useState(false)
	const [isF14Disabled, setIsF14Disabled] = useState(false)
	const [isC20Disabled, setIsC20Disabled] = useState(false)
	const [isV75TDisabled, setIsV75TDisabled] = useState(false)
	const [is12TDisabled, setIs12TDisabled] = useState(false)
	const [is19TDisabled, setIs19TDisabled] = useState(false)
	const [isTracteurSemiDisabled, setIsTracteurSemiDisabled] = useState(false)
	const [semi, setSemi] = useState(false)
	const [showElectricPalletJack, setShowElectricPalletJack] = useState(false);
	const [optionsPoidsLourds, setOptionsPoidsLourds] = useAtom(
		optionsPoidsLourdsAtom
	)
	const [optionsVehiculeLeger, setOptionsVehiculeLeger] = useAtom(
		optionsVehiculeLegerAtom
	)
	

	useOptimizedComponentWillMount(() => {
		if (preloadForm) {
			reset(preloadData)
			type_commande.current = preloadData.type_commande
			type_transport.current = preloadData.type_transport
		}
	})

	const handleOptionChange = (e) => {
		const selectedOption = e.target.value

		// Si l'option sélectionnée est "Bachée" ou "Frigorifique"
		if (selectedOption === 'Bachée' || selectedOption === 'Frigorifique') {
			// Désélectionner l'autre option si elle est sélectionnée
			const otherOption =
				selectedOption === 'Bachée' ? 'Frigorifique' : 'Bachée'
			const otherOptionCheckbox = document.querySelector(
				`[value="${otherOption}"]`
			)
			if (otherOptionCheckbox) {
				otherOptionCheckbox.checked = false
				console.log(
					'otherOptionCheckbox',
					otherOptionCheckbox.checked,
					otherOptionCheckbox.value
				)
			}
		}
	}

	const typeCommandeValue = useWatch({
		name: 'type_commande',
		defaultValue: null,
		control,
	})

	useEffect(() => {
		setValue('type_commande', 'mise-a-disposition')
	}, [setValue])

	
	const type_transport_details = useWatch({
		name: 'type_transport_details',
		defaultValue: null,
		control,
	})

	const options_poids_lourds = useWatch({
		name: 'vehicule_poids_lourds',
		defaultValue: null,
		control,
	})

	const temporisationValue = useWatch({
		name: 'temporisation',
		defaultValue: null,
		control,
	})

	const typeEtageValue = useWatch({
		name: 'type_etage',
		defaultValue: null,
		control,
	})

	const nombreEtagesValue = useWatch({
		name: 'etage',
		defaultValue: null,
		control,
	})

	const rippeurHoursValue = useWatch({
		name: 'heure_jour_rippeur',
		defaultValue: null,
		control,
	})
	const dangerValue = useWatch({
		name: 'danger',
		defaultValue: false,
		control,
	})
	const nombrePalettes = useWatch({
		name: 'nombre_palettes',
		defaultValue: 0,
		control,
	})
	const rippeursValue = useWatch({
		name: 'rippeurs',
		defaultValue: null,
		control,
	})

	const optionsPoidsLourdsValue = useWatch({
		name: 'options_poids_lourds',
		defaultValue: [],
		control,
	}) 

	const optionsVehiculeLegerValue = useWatch({
		name: 'options_vehicule_leger',
		defaultValue: [],
		control,
	}) 

	useEffect(() => {
		if (typeCommandeValue) {
			setTypeCommande(typeCommandeValue)
		}
	}, [typeCommandeValue])

	useEffect(() => {
		if (type_transport_details) {
			setTypeTransport(type_transport_details)
		}
	}, [type_transport_details])
	useEffect(() => {
		if (dangerValue) {
			setDanger(dangerValue)
		}
	}, [dangerValue])
	useEffect(() => {
		if (options_poids_lourds && options_poids_lourds.length > 0) {
			setTypeTransport(options_poids_lourds)
		}
	}, [options_poids_lourds])
	useEffect(() => {
		if (
			type_transport_details &&
			type_transport.current === 'Véhicule léger'
		) {
			setTypeTransport(type_transport_details)
		}
		if (options_poids_lourds && type_transport.current === 'Poids lourds') {
			setTypeTransport(options_poids_lourds)
		}
	}, [type_transport.current])

	useEffect(() => {
		setTemporisation(temporisationValue || 'immediat');
	}, [temporisationValue]);

	useEffect(() => {
		if (typeEtageValue) {
			setTypeEtage(typeEtageValue)
		}
	}, [typeEtageValue])

	useEffect(() => {
		if (nombreEtagesValue !== undefined) {
			setNombreEtages(nombreEtagesValue)
		}
	}, [nombreEtagesValue])

	useEffect(() => {
		if (rippeurHoursValue !== undefined) {
			setRippeurHours(rippeurHoursValue)
		}
	}, [rippeurHoursValue])

	useEffect(() => {
		if (rippeursValue !== undefined) {
			setRippeurs(rippeursValue)
		}
	}, [rippeursValue])

	useEffect(() => {
		if (optionsPoidsLourdsValue) {
			setOptionsPoidsLourds(optionsPoidsLourdsValue)
		}
	}, [optionsPoidsLourdsValue])
		useEffect(() => {
			const isNonChauffeurHandling = watch(`manutention_chauffeur`)
			const nombreRippeur = watch(`nombre_rippeur`)

			if (user?.activerRippeur) {
				setIsEtageDisabled(
					isNonChauffeurHandling === 'false' && nombreRippeur <= 0
				)
				if (isNonChauffeurHandling === 'false' && nombreRippeur <= 0) {
					setValue(`etage`, 'RDC')
					setValue(`escalier`, '')
					setValue(`ascenseur`, '')
				}
			} else {
				setIsEtageDisabled(isNonChauffeurHandling === 'false')
				if (isNonChauffeurHandling === 'false') {
					setValue(`etage`, 'RDC')
					setValue(`escalier`, false)
					setValue(`ascenseur`, false)
				}
			}
	
			if (isNonChauffeurHandling === 'true' || nombreRippeur > 0) {
				setIsEtageDisabled(false)
			}
	
			// Disable escalier and ascenseur when RDC is selected
			const currentEtage = watch(`etage`)
			if (currentEtage === 'RDC') {
				setValue(`escalier`, false)
				setValue(`ascenseur`, false)
			}
		}, [
			watch(`manutention_chauffeur`),
			watch(`nombre_rippeur`),
			watch(`etage`),
		])
	

	useEffect(() => {
		if (optionsVehiculeLegerValue) {
			setOptionsVehiculeLeger(optionsVehiculeLegerValue)
		}
	}, [optionsVehiculeLegerValue])
	const handleNext = (e) => {
		e.preventDefault()
		setStep(step + 1)
		setIsStepOne(true)
		const formSection = document.getElementById('form')

		if (formSection) {
			formSection.scrollIntoView({ behavior: 'smooth' })
		}
	}

	const handlePrevious = (e) => {
		e.preventDefault()
		setStep(step - 1)
		const formSection = document.getElementById('form')

		if (formSection) {
			formSection.scrollIntoView({ behavior: 'smooth' })
		}
	}

	// O
	useEffect(() => {
		if (watch(`nature_chargement`) === 'palette') {
			setIsBreakDisabled(false)
			setIsF12Disabled(false)
			setIsF14Disabled(false)
			setIsC20Disabled(false)
			setIsV75TDisabled(false)
			setIs12TDisabled(false)
			setIs19TDisabled(false)
			setIsTracteurSemiDisabled(false)
			const numPalettes = Number(watch('nombre_palettes'))
			setIsBreakDisabled(2 < numPalettes)
			setIsF12Disabled(5 < numPalettes)
			setIsF14Disabled(6 < numPalettes)
			setIsC20Disabled(7 < numPalettes)
			setIsV75TDisabled(16 < numPalettes)
			setIs12TDisabled(19 < numPalettes)
			setIs19TDisabled(22 < numPalettes)
			setIsTracteurSemiDisabled(32 < numPalettes)

			const transportMappings = [
				{
					threshold: 2,
					detail: 'Break',
					field: 'type_transport_details',
				},
				{
					threshold: 5,
					detail: 'Fourgon 12m³',
					field: 'type_transport_details',
				},
				{
					threshold: 6,
					detail: 'Fourgon 14m³',
					field: 'type_transport_details',
				},
				{
					threshold: 7,
					detail: 'Camion 20m³',
					field: 'type_transport_details',
				},
				{
					threshold: 16,
					detail: '7,5 Tonnes',
					field: 'vehicule_poids_lourds',
				},
				{
					threshold: 19,
					detail: '12 Tonnes',
					field: 'vehicule_poids_lourds',
				},
				{
					threshold: 22,
					detail: '19 Tonnes',
					field: 'vehicule_poids_lourds',
				},
				{
					threshold: 32,
					detail: 'Tracteur+semi',
					field: 'vehicule_poids_lourds',
				},
			]

			transportMappings.forEach((mapping) => {
				if (
					numPalettes > mapping.threshold &&
					watch(`${mapping.field}`) === mapping.detail
				) {
					setValue(`${mapping.field}`, null)
				}
			})
		}
	}, [
		watch(`nature_chargement`),
		watch('nombre_palettes'),
		watch(`type_transport_details`),
		watch(`vehicule_poids_lourds`),
	])
		useEffect(() => {
			const natureChargement = watch(`nature_chargement`)
			const nombrePalettes =
				Number(watch(`nombre_palettes`)) || 0
			const nombreDimension =
				Number(watch(`nombre_dimension`)) || 0
			const poidsTotal = Number(watch(`poids_total`)) || 0
	
			// Transport mapping configurations, maybe I will be moving it to some sort of constant file later
			const getTransportMappings = (nature) => {
				const mappings = {
					palette: [
						{
							threshold: 2,
							detail: 'Break',
							field: 'type_transport_details',
						},
						{
							threshold: 5,
							detail: 'Fourgon 12m³',
							field: 'type_transport_details',
						},
						{
							threshold: 6,
							detail: 'Fourgon 14m³',
							field: 'type_transport_details',
						},
						{
							threshold: 7,
							detail: 'Camion 20m³',
							field: 'type_transport_details',
						},
						{
							threshold: 16,
							detail: '7,5 Tonnes',
							field: 'vehicule_poids_lourds',
						},
						{
							threshold: 19,
							detail: '12 Tonnes',
							field: 'vehicule_poids_lourds',
						},
						{
							threshold: 22,
							detail: '19 Tonnes',
							field: 'vehicule_poids_lourds',
						},
						{
							threshold: 33,
							detail: 'Semi',
							field: 'vehicule_poids_lourds',
						},
						{
							threshold: 33,
							detail: 'Tracteur+semi',
							field: 'vehicule_poids_lourds',
						},
					],
					vrac: [
						{
							threshold: 6,
							detail: 'Break',
							field: 'type_transport_details',
						},
						{
							threshold: 12,
							detail: 'Fourgon 12m³',
							field: 'type_transport_details',
						},
						{
							threshold: 14,
							detail: 'Fourgon 14m³',
							field: 'type_transport_details',
						},
						{
							threshold: 20,
							detail: 'Camion 20m³',
							field: 'type_transport_details',
						},
						{
							threshold: 30,
							detail: '7,5 Tonnes',
							field: 'vehicule_poids_lourds',
						},
						{
							threshold: 45,
							detail: '12 Tonnes',
							field: 'vehicule_poids_lourds',
						},
						{
							threshold: 58,
							detail: '19 Tonnes',
							field: 'vehicule_poids_lourds',
						},
						{
							threshold: 86,
							detail: 'Semi',
							field: 'vehicule_poids_lourds',
						},
					],
				}
				return mappings[nature] || []
			}
	
			const WEIGHT_LIMITS = {
				Break: 1097,
				'Fourgon 12m³': 1244,
				'Fourgon 14m³': 1353,
				'Camion 20m³': 1200,
				'7,5 Tonnes': 2470,
				'12 Tonnes': 5600,
				'19 Tonnes': 9200,
				Semi: 27000,
				'Tracteur+semi': 27000,
			}
	
			// Function to check if transport should be disabled, this jumps between weights and nature_chargement
			const isTransportDisabled = (transportDetail) => {
				const mappings = getTransportMappings(natureChargement)
				const currentQuantity =
					natureChargement === 'palette'
						? nombrePalettes
						: nombreDimension
	
				const weightExceeded = poidsTotal > WEIGHT_LIMITS[transportDetail]
	
				let quantityExceeded = false
				if (natureChargement && mappings.length > 0) {
					const mapping = mappings.find(
						(m) => m.detail === transportDetail
					)
					quantityExceeded = mapping
						? currentQuantity > mapping.threshold
						: false
				}
	
				return weightExceeded || quantityExceeded
			}
	
			const updateTransportAvailability = () => {
				setIsBreakDisabled(isTransportDisabled('Break'))
				setIsF12Disabled(isTransportDisabled('Fourgon 12m³'))
				setIsF14Disabled(isTransportDisabled('Fourgon 14m³'))
				setIsC20Disabled(isTransportDisabled('Camion 20m³'))
				setIsV75TDisabled(isTransportDisabled('7,5 Tonnes'))
				setIs12TDisabled(isTransportDisabled('12 Tonnes'))
				setIs19TDisabled(isTransportDisabled('19 Tonnes'))
				setSemi(isTransportDisabled('Semi'))
				setIsTracteurSemiDisabled(isTransportDisabled('Tracteur+semi'))
			}
	
			const clearInvalidTransportSelections = () => {
				if (!natureChargement) return // Don't clear selections if nature not chosen yet
	
				const mappings = getTransportMappings(natureChargement)
				const currentQuantity =
					natureChargement === 'palette'
						? nombrePalettes
						: nombreDimension
	
				mappings.forEach((mapping) => {
					const currentSelection = watch(
						`${mapping.field}`
					)
	
					const shouldBeDisabled = isTransportDisabled(mapping.detail)
	
					if (shouldBeDisabled && currentSelection === mapping.detail) {
						setTypeTransport(null)
						setValue(`${mapping.field}`, undefined)
					}
				})
			}
	
			const handleNatureBasedFieldClearing = () => {
				if (natureChargement === 'palette') {
					setValue(`nombre_dimension`, null)
				} else if (natureChargement === 'vrac') {
					setValue(`nombre_palettes`, null)
					setValue(`nature_palettes`, null)
				}
			}
	
			// 1. Always update transport availability (weight + conditional quantity constraints)
			updateTransportAvailability()
	
			// 2. Handle nature-specific field clearing
			handleNatureBasedFieldClearing()
	
			// 3. Clear invalid selections (only if nature is selected)
			clearInvalidTransportSelections()
		}, [
			watch(`nature_chargement`),
			watch(`nombre_dimension`),
			watch(`nombre_palettes`),
			watch(`poids_total`),
			watch(`type_transport_details`),
			watch(`vehicule_poids_lourds`)
		])

	
  
	// Nouvelle fonction de vérification avec dépendances claires
	const shouldShowElectricPalletJack = useMemo(() => {
		if (typeCommandeValue === 'mise-a-disposition') {
		  return missions?.some(mission => 
			mission?.type_transport === 'Poids lourds' && 
			Array.isArray(mission?.options_poids_lourds) && 
			mission.options_poids_lourds.includes('Hayon')
		  );
		}
		
		return (
		  watch('type_transport') === 'Poids lourds' && 
		  Array.isArray(optionsPoidsLourdsValue) && // Ajout de la vérification
		  optionsPoidsLourdsValue.includes('Hayon')
		);
	  }, [missions, typeCommandeValue, optionsPoidsLourdsValue, watch('type_transport')]);

	  useEffect(() => {
	  setShowElectricPalletJack(shouldShowElectricPalletJack);
	}, [shouldShowElectricPalletJack]);
  
    const {t} = useTranslation()
    const manutentionItems = [
		{
			label : t("handling_eq1"),
			value : "Diable"
		},
		{
			label : t("handling_eq2"),
			value : "Transpalette manuel"
		},
		{
			label : t("handling_eq3"),
			value : "Transpalette électrique"
		},
		{
			label : t("handling_eq4"),
			value : "Sangle"
		}
	]
	const epiItems = [
		{
			label : t("ppe_eq1"),
			value : "Casque"
		},
		{
			label : t("ppe_eq2"),
			value : "Gants"
		},
		{
			label : t("ppe_eq3"),
			value : "Masque"
		},
		{
			label : t("ppe_eq4"),
			value : "Lunettes"
		},
		{
			label : t("ppe_eq5"),
			value : "Chaussure de sécurité"
		},
		{
			label : t("ppe_eq6"),
			value : "Gilet de visibilité"
		}
	]
	const [isMobile, setIsMobile] = useState(() => window.innerWidth < 768);
	
		useEffect(() => {
			const checkScreen = () => {
				const width = window.innerWidth;
	
				setIsMobile(width < 768);
	
			};
			checkScreen();
			window.addEventListener('resize', checkScreen);
	
			return () => window.removeEventListener('resize', checkScreen);
		}, []);
	return (
		<StyledForm id='form' onSubmit={handleSubmit(onSubmit, onError)}>
			{step === 1 && (
				<div onSubmit={handleSubmit(onSubmit, onError)}>
					<FormContentSection>
						<div
							style={{
								display: 'flex',
								flexDirection: 'row',
								justifyContent: 'space-between',
							}}
						>
							<div
								style={{
									display: 'flex',
									flexDirection: 'row',
								}}
							>
								<FormSectionTitle>
									{t("transport_type")}
								</FormSectionTitle>

								<svg
									xmlns='http://www.w3.org/2000/svg'
									style={{
										width: 20,
										height: 20,
										marginTop: 10,
										marginLeft: 10,
									}}
									fill='none'
									viewBox='0 0 24 24'
									stroke='#51C7F2'
								>
									<path
										strokeLinecap='round'
										strokeLinejoin='round'
										strokeWidth={2}
										d='M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z'
									/>
								</svg>
							</div>
						</div>
						<FormSectionCard>
							<RadioGroup
								name='type_commande'
								options={[
									{ value: 'course-a-course', label: t("course_à_course") },
									{
										value: 'mise-a-disposition',
										label: t("mise_à_disposition"),
									},
								]}
								register={register}
								required={true}
								disabled={disabled}
								errors={errors}
							/>
							{watch('type_commande') && (
								<RadioGroup
									name='temporisation'
									options={[
										{
											value: 'immediat',
											label: t("immédiate"),
										},
										{
											value: 'planifie',
											label: t("planifiée"),
										},
									]}
									register={register}
									required={true}
									disabled={disabled}
									label= {t("timing_type")}
									errors={errors}
								/>
							)}
						</FormSectionCard>
					</FormContentSection>

					{watch('type_commande') === 'mise-a-disposition' ? (
						<InformationsMiseADispo
							unregister={unregister}
							register={register}
							watch={watch}
							setValue={setValue}
							isStepOne={isStepOne}
							control={control}
							errors={errors}
							getValues={getValues}
							display={disabled}
							setHeur={setHeur}
							keepFilesAsObjects={
								preloadForm || keepFilesAsObjects
							}
							isActiverRippeur={user?.activerRippeur}
							setPrice={setPrice}
						/>
					) : (
						<InformationCourseACourse
							unregister={unregister}
							register={register}
							watch={watch}
							setValue={setValue}
							isStepOne={isStepOne}
							control={control}
							errors={errors}
							getValues={getValues}
							display={disabled}
							heur={heur}
							setHeur={setHeur}
							initialNumberOfCourses={preloadData?.courses.length}
							keepFilesAsObjects={
								preloadForm || keepFilesAsObjects
							}
						/>
					)}
					<button
						type='submit'
						style={{
							marginBottom: '1rem',
							border: 'none',
							alignSelf: 'flex-start',
							padding: '1rem 1rem',
							background: '#72c5ed',
							color: 'white',
							fontWeight: 'bold',
							cursor: 'pointer',
							borderRadius: 5,
							fontFamily: 'Montserrat',
							width: '30%',
							marginRight: '1rem',
							marginTop: '3rem',
						}}
					>
						{t("next")}
					</button>
				</div>
			)}
			{step === 2 && (
				<div onSubmit={handleSubmit(onSubmit, onError)}>
					<FormContentSection>
						<FormSectionTitle></FormSectionTitle>
						<FormSectionCard>
							<div
								style={{
									display: 'flex',
									flexDirection: 'column',
									//marginBottom: '2.5rem',
								}}
							>
							<div
							style={{
							 display: 'flex',
							 flexDirection: 'row',
							 alignItems: 'center',
							 justifyContent: 'space-between',
							}}
							>
						   <span
							style={{
								marginBottom: '1rem',
								color: 'black',
								fontSize: 14,
							}}
							>
							{t("internal_refrence")}{' '}
							<span style={{ color: 'red' }}>*</span>
						   </span>
						   </div>
								
								<StyledInput
									type='text'
									disabled={disabled}
									placeholder=''
									{...register('ref_client', {
										required: true,
									})}
								/>
								{errors.ref_client && (
									<div
										style={{
											color: 'red',
											marginTop: '0.5rem',
										}}
									>
										{t("internal_refrence_err")}
									</div>
								)}
							</div>
						</FormSectionCard>
					</FormContentSection>
					{typeCommande === 'mise-a-disposition' && (
						<>
							<FormContentSection>
								<FormSectionTitle></FormSectionTitle>
								<FormSectionCard>
									<div
										style={{
											display: 'flex',
											flexDirection: 'column',
											marginBottom: '2.5rem',
											width: isMobile? '100%' : '50%',
										}}
									>
										<div
											style={{
												display: 'flex',
												flexDirection: 'row',
												justifyContent: 'space-between',
											}}
										>
											<span
												style={{
													marginBottom: '1rem',
													color: 'black',
													fontSize: 14,
												}}
											>
												{t("attach_documents")} (PDF)
											</span>

											<span
												style={{
													marginBottom: '1rem',
													color: 'black',
													fontSize: 14,
												}}
											>
												({t("optional")})
											</span>
										</div>

										<UploadFileCommande
											initialFiles={watch('files')}
											name='file'
											onChange={(files) => {
												if (keepFilesAsObjects) {
													setValue(
														`files`,
														files.map(
															(file) => file
														)
													)
												} else {
													setValue(
														`files`,
														files.map(
															(file) => file.id
														)
													)
												}
											}}
										/>
									</div>
								</FormSectionCard>
							</FormContentSection>
							<FormContentSection>
								<FormSectionTitle></FormSectionTitle>
								<FormSectionCard>
									<div
										style={{
											display: 'flex',
											flexDirection: isMobile? 'column' : 'row',
											marginBottom: '2rem',
											gap : isMobile? '2rem' : 0
										}}
									>
										<div
											style={{
												display: 'flex',
												flexDirection: 'column',
												width: isMobile? '100%' : '50%',
												marginRight:  '1rem',
											}}
										>
											<span
												style={{
													marginBottom: '1rem',
													color: 'black',
													fontSize: 14,
												}}
											>
												{t("nom_signataire")}{' '}
												<span style={{ color: 'red' }}>
													*
												</span>
											</span>
											<StyledInput
												type='text'
												disabled={disabled}
												placeholder=''
												{...register(`nom_signataire`, {
													required:t("nom_destinataire_err"),
													minLength: {
														value: 3,
														message:t("article_m") +t("last_name") +t("err_message2"),
													},
													pattern: {
														value: /^[A-Za-zÀ-ÖØ-öø-ÿ\s'\-]+$/,
														message: t("article_m") +t("last_name") +t("err_message3"),
													},
												})}
											/>
											{errors.nom_signataire && (
												<div
													style={{
														color: 'red',
														marginTop: '0.5rem',
													}}
												>
													{
														errors.nom_signataire
															.message
													}
												</div>
											)}
										</div>

										<div
											style={{
												display: 'flex',
												flexDirection: 'column',
												width: isMobile? '100%' : '50%',
												marginRight:  '1rem',
											}}
										>
											<span
												style={{
													marginBottom: '1rem',
													color: 'black',
													fontSize: 14,
												}}
											>
												{t("prénom_signataire")}{' '}
												<span style={{ color: 'red' }}>
													*
												</span>
											</span>
											<StyledInput
												type='text'
												disabled={disabled}
												placeholder=''
												{...register(
													`prénom_signataire`,
													{
														required:t("prenom_destinataire_err"),
														minLength: {
															value: 3,
															message:t("article_m") +t("first_name") +t("err_message2"),
														},
														pattern: {
															value: /^[A-Za-zÀ-ÖØ-öø-ÿ\s'\-]+$/,
															message:t("article_m") +t("first_name") +t("err_message3"),
														},
													}
												)}
											/>
											{errors.prénom_signataire && (
												<div
													style={{
														color: 'red',
														marginTop: '0.5rem',
													}}
												>
													{
														errors.prénom_signataire
															.message
													}
												</div>
											)}
										</div>
									</div>
									<div
										style={{
											display: 'flex',
											flexDirection: isMobile? 'column' :'row',
											marginBottom: '2rem',
											gap : isMobile? '2rem' : 0
										}}
									>
										<div
											style={{
												display: 'flex',
												flexDirection: 'column',
												width: isMobile? '100%' : '50%',
												marginRight: '1rem',
											}}
										>
											<span
												style={{
													marginBottom: '1rem',
													color: 'black',
													fontSize: 14,
												}}
											>
												{t("signatory_phone_number1")}{' '}
												<span style={{ color: 'red' }}>
													*
												</span>
											</span>
											<Controller
												name='téléphone1_signataire'
												rules={{
													required:t("phone_number_err1"),
													pattern: {
														value: /^[0-9]+$/,
														message:t("phone_number_err2"),
													},
												}}
												control={control}
												render={({
													field: { onChange, value },
												}) => (
													<PhoneInput
														country='fr'
														placeholder=''
														value={value}
														onChange={onChange}
														inputStyle={{
															paddingRight:
																'1.5rem',
															paddingTop:
																'1.5rem',
															paddingBottom:
																'1.5rem',
															borderRadius:
																'0.5rem',
															border: 'none',
															fontFamily:
																'Montserrat',
															color: '#858ea8',
															flex: '1',
															display: 'flex',
															width: '100%',
														}}
														buttonStyle={{
															borderRadius:
																'0.5rem',
															border: 'none',
															fontFamily:
																'Montserrat',
															color: '#858ea8',
															flex: '1',
															display: 'flex',
														}}
													/>
												)}
											/>
											{errors.téléphone1_signataire && (
												<div
													style={{
														color: 'red',
														marginTop: '0.5rem',
													}}
												>
													{
														errors
															.téléphone1_signataire
															.message
													}
												</div>
											)}
										</div>
										<div
											style={{
												display: 'flex',
												flexDirection: 'column',
												width: isMobile? '100%' : '50%',
												marginRight: '1rem',
											}}
										>
											<span
												style={{
													marginBottom: '1rem',
													color: 'black',
													fontSize: 14,
												}}
											>
												{t("signatory_phone_number2")}{' '}
												<span style={{ color: 'red' }}>
													*
												</span>
											</span>
											<Controller
												name='téléphone2_signataire'
												rules={{
													required:t("phone_number_err1"),
													pattern: {
														value: /^[0-9]+$/,
														message:t("phone_number_err2"),
													},
												}}
												control={control}
												render={({
													field: { onChange, value },
												}) => (
													<PhoneInput
														country='fr'
														placeholder=''
														value={value}
														onChange={onChange}
														inputStyle={{
															paddingRight:
																'1.5rem',
															paddingTop:
																'1.5rem',
															paddingBottom:
																'1.5rem',
															borderRadius:
																'0.5rem',
															border: 'none',
															fontFamily:
																'Montserrat',
															color: '#858ea8',
															flex: '1',
															display: 'flex',
															width: '100%',
														}}
														buttonStyle={{
															borderRadius:
																'0.5rem',
															border: 'none',
															fontFamily:
																'Montserrat',
															color: '#858ea8',
															flex: '1',
															display: 'flex',
														}}
													/>
												)}
											/>
											{errors.téléphone2_signataire && (
												<div
													style={{
														color: 'red',
														marginTop: '0.5rem',
													}}
												>
													{
														errors
															.téléphone2_signataire
															.message
													}
												</div>
											)}
										</div>
									</div>
									<div
										style={{
											width: '100%',
											display: 'flex',
											flexDirection: 'column',
											paddingBottom: '2rem',
										}}
									>
										<span
											style={{
												color: '#262626',
												paddingBottom: '1rem',
											}}
										>
											{t("signatory_email")}{' '}
											<span style={{ color: 'red' }}>
												*
											</span>
										</span>
										<CustomInput
											type='text'
											{...register('email_signataire', {
												required:t("email_destinataire_err"),
												pattern: {
													value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
													message:t("email_err_message"),
												},
											})}
										/>
										{errors.email_signataire && (
											<div
												style={{
													color: 'red',
													marginTop: '0.5rem',
													fontSize: '14px',
												}}
											>
												{
													errors.email_signataire
														.message
												}
											</div>
										)}
									</div>
								</FormSectionCard>
							</FormContentSection>
						</>
					)}
					{typeCommande === 'course-a-course' && (
						<>
							<FormContentSection>
								<FormSectionTitle></FormSectionTitle>
								<FormSectionCard>
									<p
										style={{
											color: 'black',
											//fontWeight: 'bold',
										}}
									>
										{t("manutention")}
									</p>
						<div
							 className='radio-btn-group-palettes'
							 style={{
							display: 'flex',
							flexDirection: 'row',
							marginBottom: '2rem',
							}}
						   >
						 <div
							className='radio'
							style={{
								marginRight: '1rem',
							}}
						>
							<input
								id={`manutention_chauffeur-oui`}
								type='radio'
								value={true}
								{...register(
									`manutention_chauffeur`,
									{
										required: true,
									}
								)}
							/>

							<label htmlFor={`manutention_chauffeur-oui`}>
								{t("yes")}
							</label>
						</div>

						<div
							className='radio'
							style={{
								marginRight: '1rem',
							}}
						>
							<input
								id={`manutention_chauffeur-non`}
								type='radio'
								value={false}
								{...register(
									`manutention_chauffeur`,
									{
										required: true,
									}
								)}
							/>

							<label htmlFor={`manutention_chauffeur-non`}>
								{t("no")}
							</label>
						</div>
							</div>
									{errors.manutention_chauffeur && (
										<div
											style={{
												color: 'red',
												marginTop: '0.5rem',
											}}
										>
											{t("manutention_err")}
										</div>
									)}
								</FormSectionCard>
							</FormContentSection>
							{user?.activerRippeur && (
								<FormContentSection>
									<FormSectionTitle>{t("rippeur")}</FormSectionTitle>
									<FormSectionCard>
										<div
											style={{
												display: 'flex',
												flexDirection: 'column',
											}}
										>
											<div
												style={{
													display: 'flex',
													flexDirection: 'row',
													justifyContent:
														'space-between',
												}}
											>
												<span
													style={{
														marginBottom: '1rem',
														color: 'black',
														fontSize: 14,
													}}
												>
													{t("nombre_rippeur")}
												</span>
												<span
													style={{
														marginBottom: '1rem',
														color: 'black',
														fontSize: 14,
													}}
												>
													({t("optional")})
												</span>
											</div>
											<div
												style={{
													display: 'flex',
													flexDirection: 'row',
													alignItems: 'center',
													justifyContent: 'center',
													marginBottom: '1rem',
												}}
											>
												<div>
													<svg
														xmlns='http://www.w3.org/2000/svg'
														width='13.605'
														height='27.839'
														viewBox='0 0 13.605 27.839'
														style={{
															marginRight:
																'.5rem',
														}}
													>
														<g
															id='user'
															transform='translate(0.5 0.5)'
														>
															<path
																id='Path_11624'
																d='m³1.488,8.816A3.412,3.412,0,1,1,34.9,5.4,3.412,3.412,0,0,1,31.488,8.816Zm0-6.054a2.645,2.645,0,1,0,2.645,2.645A2.645,2.645,0,0,0,31.488,2.762Z'
																transform='translate(-25.195 -1.992)'
																fill='#51c7f2'
																stroke='#51c7f2'
																strokeWidth='1'
															/>
															<path
																id='Path_11625'
																d='m³0.917,33.11h-.752a.383.383,0,1,1,0-.767h.752A1.484,1.484,0,0,0,32.4,30.861V24.829a1.7,1.7,0,0,0-1.7-1.7H23.03a1.7,1.7,0,0,0-1.7,1.7v6.034a1.484,1.484,0,0,0,1.484,1.481h.725a.383.383,0,1,1,0,.767h-.725a2.252,2.252,0,0,1-2.249-2.249V24.829A2.472,2.472,0,0,1,23.03,22.36H30.7a2.472,2.472,0,0,1,2.469,2.469v6.034A2.252,2.252,0,0,1,30.917,33.11Z'
																transform='translate(-20.562 -14.552)'
																fill='#51c7f2'
																stroke='#51c7f2'
																strokeWidth='1'
															/>
															<path
																id='Path_11626'
																d='m³8.027,48.646A2.029,2.029,0,0,1,36,46.619V40.231a.383.383,0,0,1,.767,0v6.388a1.26,1.26,0,0,0,2.52,0V34.509a.383.383,0,0,1,.767,0v12.11A2.029,2.029,0,0,1,38.027,48.646Z'
																transform='translate(-30.081 -21.807)'
																fill='#51c7f2'
																stroke='#51c7f2'
																strokeWidth='1'
															/>
															<path
																id='Path_11627'
																d='M29.453,48.646a2.029,2.029,0,0,1-2.027-2.027V34.509a.383.383,0,0,1,.767,0v12.11a1.26,1.26,0,0,0,2.52,0V40.231a.383.383,0,0,1,.767,0v6.388A2.029,2.029,0,0,1,29.453,48.646Z'
																transform='translate(-24.794 -21.807)'
																fill='#51c7f2'
																stroke='#51c7f2'
																strokeWidth='1'
															/>
														</g>
													</svg>
												</div>

							<CustomInput
								width={'100%'}
								type='number'
								defaultValue={0}
								min={0}
								max={2}
								{...register(`nombre_rippeur`, {
									valueAsNumber: true,
									min: {
										value: 0,
										message:t("nombre_rippeur_err1"),
									},
									max: {
										value: 2,
										message:t("nombre_rippeur_err2"),
									},
								})}
								onBlur={(e) => {
									const val = parseInt(e.target.value, 10)
									if (isNaN(val)) {
										setValue(
											`nombre_rippeur`,
											0
										)
									} else if (val > 2) {
										setValue(
											`nombre_rippeur`,
											2
										)
									}
								}}
								onInput={(e) => {
									const val = parseInt(e.target.value, 10)
									if (val > 2) {
										e.target.value = 2
									}
								}}
								onKeyDown={(e) => {
									if (['e', 'E', '+', '-'].includes(e.key)) {
										e.preventDefault() 
									}
								}}
							/>
											</div>

											<div
												style={{
													display: 'flex',
													flexDirection: 'row',
													justifyContent:
														'space-between',
												}}
											>
												<span
													style={{
														marginBottom: '1rem',
														color: 'black',
														fontSize: 14,
													}}
												>
													{t("number_of_hours")}
												</span>
											</div>
											<div
												style={{
													display: 'flex',
													flexDirection: 'row',
													alignItems: 'center',
													justifyContent: 'center',
												}}
											>
												<Select
													disabled={disabled}
													{...register(
														'heure_rippeur'
													)}
												>
													{Array.from(
														{ length: 12 },
														(v, i) => i + 1
													).map((i) => (
														<option
															key={String(i)}
															value={String(i)}
														>
															{i}h
														</option>
													))}
												</Select>
											</div>
										</div>
									</FormSectionCard>
								</FormContentSection>
							)}
							<FormContentSection>
								<FormSectionTitle>
									{t("delivery_location")}
								</FormSectionTitle>
								<FormSectionCard>
									<div
										className='radio-btn-group-palettes'
										style={{
											display: 'flex',
											flexDirection: 'row',
											marginBottom: '2rem',
										}}
									>
										<div
											className='radio'
											style={{
												marginRight: '1rem',
											}}
										>
											<input
												id='livraison-1'
												type='radio'
												disabled={disabled}
												value='Entrepot/Magasin/Chantier'
												{...register('livraison', {
													required: true,
												})}
											/>

											<label htmlFor='livraison-1'>
												{t("pickup_point1")}
											</label>
										</div>

										<div
											className='radio'
											style={{
												marginRight: '1rem',
											}}
										>
											<input
												id='livraison-2'
												type='radio'
												disabled={disabled}
												value='Domicile/Batiment/Maison'
												{...register('livraison', {
													required: true,
												})}
											/>

											<label htmlFor='livraison-2'>
												{t("pickup_point2")}
											</label>
										</div>
									</div>
									{errors.livraison && (
										<div
											style={{
												color: 'red',
												marginTop: '0.5rem',
											}}
										>
											{t("pickup_point_err")}.
										</div>
									)}
									<div>
										{livraison.current ===
											'Domicile/Batiment/Maison' && (
											<div
												style={{
													display: 'flex',
													flexDirection: 'row',
												}}
											>
									<div
									style={{
										display: 'flex',
										flexDirection: 'row',
										alignItems: 'center',
										justifyContent: 'center',
										width: '40%',
										marginRight: '1rem',
										position: 'relative',
									}}
								>
									<div
										style={{
											display: 'flex',
											alignItems: 'center',
											marginRight: '0.5rem',
											position: 'relative',
										}}
									>
										<span
											style={{
												marginRight: '0.5rem',
												color: 'black',
												fontSize: 14,
											}}
										>
											{t("floor")}
										</span>
										<div
											style={{
												position: 'relative',
												display: 'inline-block',
											}}
										>
											<button
												type='button'
												style={{
													background: 'none',
													border: 'none',
													padding: 0,
													cursor: 'pointer',
													display: 'flex',
													alignItems: 'center',
												}}
												onMouseEnter={() =>
													setShowTooltip(true)
												}
												onMouseLeave={() =>
													setShowTooltip(false)
												}
											>
												<Info
													size={16}
													color='#858ea8'
													strokeWidth={2}
												/>
											</button>

											{/* Tooltip CSS-only */}
											<div
												style={{
													display: showTooltip
														? 'block'
														: 'none',
													position: 'absolute',
													left: '100%',
													top: 0,
													minWidth: '220px',
													backgroundColor: 'white',
													border: '1px solid #ddd',
													borderRadius: '4px',
													padding: '0.75rem',
													boxShadow:
														'0 2px 8px rgba(0,0,0,0.1)',
													zIndex: 1000,
													fontSize: '0.875rem',
												}}
											>
												<div
													style={{
														marginBottom: '0.25rem',
														fontWeight: 500,
													}}
												>
													{t("floor_selection")} :
												</div>
												<ul
													style={{
														listStyle: 'none',
														margin: 0,
														padding: 0,
													}}
												>
													<li>
														- {t("floor_selection_option1")}
													</li>
													<li>
														- {t("floor_selection_option2")}
													</li>
												</ul>
											</div>
										</div>
									</div>

									<Select
										style={{
											width: '100%',
											backgroundColor: isEtageDisabled
												? '#f3f4f6'
												: 'white',
										}}
										disabled={isEtageDisabled}
										{...register(`etage`, {
											required: true,
										})}
									>
										<option value='RDC'>
											{t("ground_floor")}
										</option>
										<option value='1-10'>1-10</option>
										<option value='11-20'>11-20</option>
										<option value='21-30'>21-30</option>
									</Select>
									</div>
										{!isEtageDisabled &&
									watch(`etage`) !== 'RDC' && (
										<div
											style={{
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'flex-start',
											}}
										>
											<Controller
												name={`escalier`}
												control={control}
												rules={{
													validate: (value) => {
														const etage = getValues(
															`etage`
														)
														const ascenseur =
															getValues(
																`ascenceur`
															)
														if (
															etage !== 'RDC' &&
															!value &&
															!ascenseur
														) {
															return 'Sélectionnez escalier ou ascenseur'
														}
														return true
													},
												}}
												render={({ field }) => (
													<input
														type='checkbox'
														style={{
															marginRight: '1rem',
															backgroundColor:
																isEtageDisabled ||
																watch(
																	`etage`
																) === 'RDC'
																	? '#f3f4f6'
																	: 'white',
														}}
														disabled={
															isEtageDisabled ||
															watch(
																`etage`
															) === 'RDC'
														}
														checked={
															field.value === true
														}
														onChange={(e) =>
															field.onChange(
																e.target.checked
																	? true
																	: false
															)
														}
													/>
												)}
											/>

											<span
												style={{
													marginRight: '0.5rem',
												}}
											>
												{t("stairs")}
											</span>
										</div>
									)}

								{!isEtageDisabled &&
									watch(`etage`) !== 'RDC' && (
										<div
											style={{
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'flex-start',
											}}
										>
											<Controller
												name={`ascenseur`}
												control={control}
												rules={{
													validate: (value) => {
														const etage = getValues(
															`etage`
														)
														const escalier =
															getValues(
																`escalier`
															)
														if (
															etage !== 'RDC' &&
															!value &&
															!escalier
														) {
															return 'Sélectionnez escalier ou ascenseur'
														}
														return true
													},
												}}
												render={({ field }) => (
													<input
														type='checkbox'
														style={{
															marginRight: '1rem',
															backgroundColor:
																isEtageDisabled ||
																watch(
																	`etage`
																) === 'RDC'
																	? '#f3f4f6'
																	: 'white',
														}}
														disabled={
															isEtageDisabled ||
															watch(
																`etage`
															) === 'RDC'
														}
														checked={
															field.value === true
														}
														onChange={(e) =>
															field.onChange(
																e.target.checked
																	? true
																	: false
															)
														}
													/>
												)}
											/>

											<span
												style={{
													marginRight: '0.5rem',
												}}
											>
												{t("elevator")}
											</span>
										</div>
									)}

											</div>
										)}
									</div>
									
								</FormSectionCard>
							</FormContentSection>

							{['chauffeur', 'transporter'].indexOf(
								user?.role
							) === -1 && (
								<FormContentSection>
									<FormSectionTitle>
										{t("insurance")}
									</FormSectionTitle>
									<FormSectionCard>
										<p
											style={{
												color: 'red',
												fontWeight: 'bold',
											}}
										>
											{t("goods_insurance")}
										</p>

										<p
											style={{
												color: 'black',
												fontWeight: 'bold',
											}}
										>
											{t("shipment_value")}
										</p>

					<div
						className='radio-btn-group-palettes'
						style={{
							display: 'flex',
							flexDirection: 'row',
							marginBottom: '2rem',
						}}
					>
						<div
							className='radio'
							style={{
								marginRight: '1rem',
							}}
						>
							<input
								id={`assurance-oui`}
								type='radio'
								value={true}
								{...register(`assurance`, {
									required: true,
								})}
							/>

							<label htmlFor={`assurance-oui`}>Oui</label>
						</div>

						<div
							className='radio'
							style={{
								marginRight: '1rem',
							}}
						>
							<input
								id={`assurance-non`}
								type='radio'
								value={false}
								{...register(`assurance`, {
									required: true,
								})}
							/>

							<label htmlFor={`assurance-non`}>Non</label>
						</div>
					</div>
										{errors.assurance && (
											<div
												style={{
													color: 'red',
													marginTop: '0.5rem',
												}}
											>
												{t("insurance_err1")}
											</div>
										)}
										<div>
											{assurance.current === 'true' && (
												<div
													style={{
														display: 'flex',
														flexDirection: 'column',
													}}
												>
													<div
														style={{
															display: 'flex',
															flexDirection:
																'column',
															alignItems:
																'center',
															justifyContent:
																'center',
															//width: '30%',
															marginRight: '1rem',
														}}
													>
														<span
															style={{
																color: 'black',
																fontWeight:
																	'bold',
																marginBottom:
																	'1rem',
															}}
														>
															{t("load_value")}
														</span>

														<div
															style={{
																position:
																	'relative',
																width: '100%',
															}}
														>
															<CustomInput
																width={'100%'}
																type='text'
																disabled={
																	disabled
																}
																{...register(
																	'assurance_amount',
																	{
																		validate:
																			(
																				value
																			) => {
																				const numericValue =
																					Number(
																						value.replace(
																							' ',
																							''
																						)
																					)
																				const onlyDigits =
																					/^\d+$/
																				return (
																					!isNaN(
																						numericValue
																					) &&
																					onlyDigits.test(
																						value
																					)
																				)
																			},
																		required: true,
																	}
																)}
															/>
															<span
																style={{
																	position:
																		'absolute',
																	right: '3rem',
																	top: '1rem',
																	color: 'red',
																}}
															>
																€
															</span>
														</div>
													</div>

													<p
														style={{
															color: 'black',
															fontWeight: 'bold',
														}}
													>
														{t("load_value_option")}
													</p>
													{errors.assurance_amount && (
														<div
															style={{
																color: 'red',
																marginTop:
																	'0.5rem',
															}}
														>
															{t("insurance_err2")}
														</div>
													)}
												</div>
											)}
										</div>
									</FormSectionCard>
								</FormContentSection>
							)}
						</>
					)}

					<div
						style={{
							marginTop: '1rem',
							display: 'flex',
							flexDirection: 'row',
						}}
					>
						<button
							onClick={(e) => handlePrevious(e)}
							type='button'
							style={{
								marginBottom: '1rem',
								border: 'none',
								alignSelf: 'flex-start',
								padding: '1rem 2rem',
								background: '#72c5ed',
								color: 'white',
								fontWeight: 'bold',
								cursor: 'pointer',
								borderRadius: 5,
								width:  isMobile? '50%' :'20%',
								fontFamily: 'Montserrat',
								marginRight: '1rem',
								marginTop: '3rem',
							}}
						>
							 {t("previous")}
						</button>
						<button
							type='submit'
							style={{
								marginBottom: '1rem',
								border: 'none',
								alignSelf: 'flex-start',
								padding: '1rem 2rem',
								background: '#72c5ed',
								color: 'white',
								fontWeight: 'bold',
								cursor: 'pointer',
								borderRadius: 5,
								fontFamily: 'Montserrat',
								width:  isMobile? '50%' :'20%',
								marginRight: '1rem',
								marginTop: '3rem',
							}}
						>
							 {t("next")}
						</button>
					</div>
				</div>
			)}
			{step === 3 && typeCommande === 'course-a-course' && (
				<>
				<FormContentSection>
				<FormSectionTitle>
				  {t("total_weight")} (kg) 
				</FormSectionTitle>
				<FormSectionCard>
					<CustomInput
						width={'100%'}
						type='number'
						min={0}
						{...register(`poids_total`, {
							required: true,
							min: {
								value: 0,
								message: t("total_weight_err1"),
							},
						})}
					/>
					{errors &&
						errors.poids_total && (
							<div style={{ color: 'red', marginTop: '0.5rem' }}>
								{errors.poids_total.message ||
									t("total_weight_err2")}
							</div>
						)}
				 </FormSectionCard>
				</FormContentSection>
					<FormContentSection>
						<FormSectionTitle>
							{t("load_type")}
						</FormSectionTitle>
						<FormSectionCard>
							<div
								className='radio-btn-group-palettes'
								style={{
									display: 'flex',
									flexDirection: 'row',
									marginBottom: '2rem',
								}}
							>
								<div
									className='radio'
									style={{
										marginRight: '1rem',
									}}
								>
									<input
										id={`nature-chargement-1`}
										type='radio'
										value='vrac'
										{...register(`nature_chargement`, {
											required: true,
										})}
									/>

									<label htmlFor={`nature-chargement-1`}>
										{t("bulk")}
									</label>
								</div>

								<div
									className='radio'
									style={{
										marginRight: '1rem',
									}}
								>
									<input
										id={`nature-chargement-2`}
										type='radio'
										value='palette'
										{...register(`nature_chargement`, {
											required: true,
										})}
									/>

									<label htmlFor={`nature-chargement-2`}>
										{t("pallet")}
									</label>
								</div>
							</div>

							{errors && errors.nature_chargement && (
								<div
									style={{
										color: 'red',
										marginTop: '0.5rem',
									}}
								>
									{t("load_type_err")}
								</div>
							)}
							<div>
								{nature_chargement.current === 'palette' && (
									<div
										style={{
											display: 'flex',
											flexDirection: 'column',
											marginBottom: '1rem',
										}}
									>
										<div
											style={{
												display: 'flex',
												flexDirection: 'column',
												marginBottom: '1.5rem',
												width: '100%',
											}}
										>
											<>
												<span
													style={{
														marginBottom: '1rem',
														color: 'black',
														fontSize: 14,
													}}
												>
													{t("number_of_pallets")}{' '}
													<span
														style={{ color: 'red' }}
													>
														*
													</span>
												</span>
												<CustomInput
													width={'100%'}
													type='number'
													min={1}
													{...register( `nombre_palettes`,
													{ required: true }
													)}
												/>
												{errors &&
													errors.nombre_palettes && (
														<div
															style={{
																color: 'red',
																marginTop:
																	'0.5rem',
															}}
														>
															{t("number_of_pallets_err")}
														</div>
													)}
											</>
										</div>

										<div
											style={{
												display: 'flex',
												flexDirection: 'column',
												//marginBottom: '2.5rem',
												width: '100%',
											}}
										>
											<span
												style={{
													marginBottom: '1rem',
													color: 'black',
													fontSize: 14,
												}}
											>
												{t("pallet_nature" )}{' '}
												<span style={{ color: 'red' }}>
													*
												</span>
											</span>
											<StyledTextArea
												type='text'
												rows={4}
												placeholder=''
												{...register(
													`nature_palettes`,
													{ required: true }
												)}
											/>
											{errors &&
												errors.nature_palettes && (
													<div
														style={{
															color: 'red',
															marginTop: '0.5rem',
														}}
													>
														{t("pallet_nature_err")}
													</div>
												)}
										</div>
									</div>
								)}
								{nature_chargement.current === 'vrac' && (
									<div
										style={{
											position: 'relative',
											width: '100%',
										}}
									>
										<CustomInput
											width={'100%'}
											type='number'
											required={true}
											min={1}
											{...register(`nombre_dimension`)}
										/>
										<span
											style={{
												position: 'absolute',
												right: '3rem',
												top: '1rem',
											}}
										>
											M³
										</span>
									</div>
								)}
							</div>
						</FormSectionCard>
					</FormContentSection>
					<FormContentSection>
						<FormSectionTitle>{t("transport_details")}</FormSectionTitle>
						<p>
							<b>
								{t("transport_details_p")}
							</b>
						</p>
						<FormSectionCard>
							<div
								style={{
									display: 'flex',
									flexDirection: 'column',
									//marginBottom: '1rem',
								}}
							>
								<span
									style={{
										marginBottom: '1rem',
										color: 'black',
										fontSize: 14,
									}}
								>
									{t("transport_type")}
								</span>
								<div
									style={{
										display: 'flex',
										flexDirection: 'column',
										//marginBottom: '1rem',
									}}
								>
									<div
										style={{
											display: 'flex',
											flexDirection: isMobile? 'column' : 'row',
											marginBottom: '1rem',
											gap : isMobile ? '1rem' : 0
										}}
									>
										<div
											style={{
												width: '15rem',
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'flex-start',
											}}
										>
											<input
												type='radio'
												disabled={disabled}
												style={{
													marginRight: '1rem',
												}}
												{...register('type_transport', {
													required: true,
												})}
												value={'Véhicule léger'}
											/>

											<span
												style={{
													marginRight: '0.5rem',
												}}
											>
												{t("vehicle_type2")}
											</span>
											<img
												src={VehiculeLeger}
												style={{
													width: 40,
												}}
												alt=''
											/>
										</div>

										<div
											style={{
												width: '15rem',
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'flex-start',
											}}
										>
											<input
												style={{
													marginRight: '1rem',
												}}
												disabled={disabled}
												type='radio'
												{...register('type_transport', {
													required: true,
												})}
												value={'Poids lourds'}
											/>

											<span
												style={{
													marginRight: '0.5rem',
												}}
											>
												{t("vehicle_type1")}
											</span>

											<img
												src={PoidsLours}
												style={{
													width: 40,
												}}
												alt=''
											/>
										</div>
									</div>
								</div>
							</div>

							{type_transport.current && (
								<>
									<Seperator />

									<div
										style={{
											display: 'flex',
											flexDirection: 'row',
											//marginBottom: '1rem',
										}}
									>
										{type_transport.current !==
											'Poids lourds' && (
											<div
												style={{
													display: 'flex',
													flexDirection: 'column',
													width: '100%',
												}}
											>
												<div style={{ width: '100%' }}>
													<div
														style={{
															display: 'flex',
															flexDirection: isMobile? 'column' : 'row',
															marginBottom:'1rem',
															width: '100%',
															gap : isMobile? '1rem' : 0
														}}
													>
														<div
															style={{
																display: 'flex',
																flexDirection:
																	'column',
																width:isMobile? '100%' : '48%',
																marginRight: isMobile? 0:'2%',
															}}
														>
															<div
																style={{
																	width: '100%',
																	height: 'auto',
																	marginBottom:
																		'0.5rem',
																}}
															>
																<img
																	src={Break}
																	style={{
																		width: '100%',
																		height: 'auto', // Pour conserver les proportions de l'image
																		maxWidth:
																			'120px', // Limiter la largeur de l'image
																		maxHeight:
																			'80px', // Limiter la hauteur de l'image
																		objectFit:
																			'cover', // Ajuster la taille tout en conservant les proportions
																	}}
																	alt=''
																/>
															</div>

															<div
																style={{
																	width: isMobile? '100%' : '50%',
																	display:
																		'flex',
																	alignItems:
																		'center',
																	justifyContent:
																		'flex-start',
																}}
															>
																<input
																	type='radio'
																	style={{
																		marginRight:
																			'1rem',
																	}}
																	disabled={
																		isBreakDisabled
																	}
																	{...register(
																		'type_transport_details',
																		{
																			required: true,
																		}
																	)}
																	value='Break'
																/>

																<span
																	style={{
																		marginRight:
																			'0.5rem',
																	}}
																>
																	{t("break")}
																</span>
															</div>
															<div
																style={{
																	marginLeft: 36,
																}}
															>
																<span
																	style={{
																		fontWeight:
																			'bold',
																		fontSize:
																			'14px',
																		marginRight:
																			'0.5rem',
																		marginRight:
																			'0.5rem',
																	}}
																>
																	1097 kg
																</span>
															</div>

															<div
																style={{
																	display:
																		'flex',
																	flexDirection:
																		'column',
																	background:
																		'#f2f3f4',
																	padding: 10,
																	width: isMobile? '100%' : '70%',
																	borderRadius:
																		'5px',
																	marginTop:
																		'10px',
																	fontSize:
																		'14px',
																	lineHeight:
																		'1.5',
																}}
															>
																<span>
																	{t("vehicle_detail1")} : 6m³{' '}
																</span>
																<span>
																	{t("vehicle_detail2")} :
																	3750mm{' '}
																</span>
																<span>
																	{t("vehicle_detail3")} :
																	1956mm{' '}
																</span>
																<span>
																	{t("vehicle_detail4")} :
																	1320mm{' '}
																</span>
																<span>
																	{t("vehicle_detail5")} :
																	1097kg{' '}
																</span>
																<span>
																	{t("vehicle_detail6")}: 2
																	pal europe{' '}
																</span>
															</div>
														</div>
														<div
															style={{
																display: 'flex',
																flexDirection:
																	'column',
																width: isMobile? '100%' : '48%',
															}}
														>
															<div
																style={{
																	width: '100%',
																	height: 'auto',
																	marginBottom:
																		'0.5rem',
																}}
															>
																<img
																	src={
																		Fourgon12
																	}
																	style={{
																		width: '100%',
																		height: 'auto',
																		maxWidth:
																			'120px',
																		maxHeight:
																			'80px',
																		objectFit:
																			'cover',
																	}}
																	alt=''
																/>
															</div>

															<div
																style={{
																	display:
																		'flex',
																	alignItems:
																		'center',
																	justifyContent:
																		'flex-start',
																}}
															>
																<input
																	type='radio'
																	style={{
																		marginRight:
																			'1rem',
																	}}
																	disabled={
																		isF12Disabled
																	}
																	{...register(
																		'type_transport_details',
																		{
																			required: true,
																		}
																	)}
																	value='Fourgon 12m³'
																/>

																<span
																	style={{
																		marginRight:
																			'0.5rem',
																	}}
																>
																	{t("fourgon")} 12m³
																</span>
															</div>
															<div
																style={{
																	marginLeft: 36,
																}}
															>
																<span
																	style={{
																		fontSize:
																			'14px',
																		marginRight:
																			'0.5rem',
																		fontWeight:
																			'bold',
																	}}
																>
																	1244 kg
																</span>
															</div>
															<div
																style={{
																	display:
																		'flex',
																	flexDirection:
																		'column',
																	background:
																		'#f2f3f4',
																	padding: 10,
																	width: isMobile?'100%' : '70%',
																	borderRadius:
																		'5px',
																	marginTop:
																		'10px',
																	fontSize:
																		'14px',
																	lineHeight:
																		'1.5',
																}}
															>
																<span>
																	{t("vehicle_detail1")} : 12M3{' '}
																</span>
																<span>
																	{t("vehicle_detail2")} :
																	3030mm{' '}
																</span>
																<span>
																	{t("vehicle_detail3")} :
																	2070mm{' '}
																</span>
																<span>
																	{t("vehicle_detail4")} :
																	1320mm{' '}
																</span>
																<span>
																	{t("vehicle_detail5")} :
																	1244kg{' '}
																</span>
																<span>
																	{t("vehicle_detail6")} : 5
																	pal europe
																</span>
															</div>
														</div>

														{/* ))} */}
													</div>
												</div>
												<div style={{ width: '100%' }}>
													<div
														style={{
															display: 'flex',
															flexDirection: isMobile? 'column' : 'row',
															marginBottom:'1rem',
															width: '100%',
															gap : isMobile? '1rem' : 0
														}}
													>
														<div
															style={{
																display: 'flex',
																flexDirection:
																	'column',
																width: isMobile? '100%' : '48%',
																marginRight: isMobile? 0 : '2%',
															}}
														>
															<div
																style={{
																	width: '100%',
																	height: 'auto',
																	marginBottom:
																		'0.5rem',
																}}
															>
																<img
																	src={
																		Fourgon14
																	}
																	style={{
																		width: '100%',
																		height: 'auto',
																		maxWidth:
																			'120px',
																		maxHeight:
																			'80px',
																		objectFit:
																			'cover',
																	}}
																	alt=''
																/>
															</div>

															<div
																style={{
																	display:
																		'flex',
																	alignItems:
																		'center',
																	justifyContent:
																		'flex-start',
																}}
															>
																<input
																	type='radio'
																	style={{
																		marginRight:
																			'1rem',
																	}}
																	disabled={
																		isF14Disabled
																	}
																	{...register(
																		'type_transport_details',
																		{
																			required: true,
																		}
																	)}
																	value='Fourgon 14m³'
																/>

																<span
																	style={{
																		marginRight:
																			'0.5rem',
																	}}
																>
																	{t("fourgon")} 14m³
																</span>
															</div>
															<div
																style={{
																	marginLeft: 36,
																}}
															>
																<span
																	style={{
																		fontSize:
																			'14px',
																		fontWeight:
																			'bold',
																		marginRight:
																			'0.5rem',
																	}}
																>
																	1353 kg
																</span>
															</div>
															<div
																style={{
																	display:
																		'flex',
																	flexDirection:
																		'column',
																	background:
																		'#f2f3f4',
																	padding: 10,
																	width: isMobile? '100%' : '70%',
																	borderRadius:
																		'5px',
																	marginTop:
																		'10px',
																	fontSize:
																		'14px',
																	lineHeight:
																		'1.5',
																}}
															>
																<span>
																	{t("vehicle_detail1")} : 14M3{' '}
																</span>
																<span>
																	{t("vehicle_detail2")} :
																	3680mm{' '}
																</span>
																<span>
																	{t("vehicle_detail3")} :
																	2070mm{' '}
																</span>
																<span>
																	{t("vehicle_detail4")} :
																	1820mm{' '}
																</span>
																<span>
																	{t("vehicle_detail5")} :
																	1353kg{' '}
																</span>
																<span>
																	{t("vehicle_detail6")} : 6
																	pal europe
																</span>
															</div>
														</div>
														<div
															style={{
																display: 'flex',
																flexDirection:
																	'column',
																width: isMobile? '100%' : '48%',
															}}
														>
															<div
																style={{
																	width: '100%',
																	height: 'auto',
																	marginBottom:
																		'0.5rem',
																}}
															>
																<img
																	src={
																		vehiculeCamion
																	}
																	style={{
																		width: '100%',
																		height: 'auto',
																		maxWidth:
																			'110px',
																		maxHeight:
																			'80px',
																		objectFit:
																			'cover',
																	}}
																	alt=''
																/>
															</div>
															<div
																style={{
																	display:
																		'flex',
																	alignItems:
																		'center',
																	justifyContent:
																		'flex-start',
																}}
															>
																<input
																	type='radio'
																	style={{
																		marginRight:
																			'1rem',
																	}}
																	disabled={
																		isC20Disabled
																	}
																	{...register(
																		'type_transport_details',
																		{
																			required: true,
																		}
																	)}
																	value='Camion 20m³'
																/>

																<span
																	style={{
																		marginRight:
																			'0.5rem',
																	}}
																>
																	{t("camion")} 20m³
																</span>
															</div>
															<div
																style={{
																	marginLeft: 36,
																}}
															>
																<span
																	style={{
																		fontSize:
																			'14px',
																		marginRight:
																			'0.5rem',
																		fontWeight:
																			'bold',
																	}}
																>
																	1200 kg
																</span>
															</div>

															<div
																style={{
																	display:
																		'flex',
																	flexDirection:
																		'column',
																	background:
																		'#f2f3f4',
																	padding: 10,
																	width: isMobile? '100%' : '70%',
																	borderRadius:
																		'5px',
																	marginTop:
																		'10px',
																	fontSize:
																		'14px',
																	lineHeight:
																		'1.5',
																}}
															>
																<span>
																	{t("vehicle_detail1")} : 20m³{' '}
																</span>
																<span>
																	{t("vehicle_detail2")} :
																	4320mm{' '}
																</span>
																<span>
																	{t("vehicle_detail3")} :
																	2070mm{' '}
																</span>
																<span>
																	{t("vehicle_detail4")} :
																	2100mm{' '}
																</span>
																<span>
																	{t("vehicle_detail5")} :
																	1200kg{' '}
																</span>
																<span>
																	{t("vehicle_detail6")} : 7
																	pal europe
																</span>
															</div>
														</div>
													</div>
												</div>
											</div>
										)}
									</div>

									{type_transport.current !==
										'Poids lourds' && (
										<div
											style={{
												display: 'flex',
												flexDirection: 'column',
												//marginBottom: '2.5rem',
											}}
										>
											<span
												style={{
													marginBottom: '1rem',
													color: 'black',
													fontSize: 14,
												}}
											>
												{t("light_vehicle_options")}
											</span>

											<div
												style={{
													display: 'flex',
													flexDirection: 'column',
													marginBottom: '1rem',
												}}
											>
												<div
													style={{
														display: 'flex',
														flexDirection: isMobile? 'column' : 'row',
														marginBottom: '1rem',
														gap : isMobile ? '1rem' : 0
													}}
												>
													<div
														style={{
															width: '15rem',
															display: 'flex',
															alignItems:
																'center',
															justifyContent:
																'flex-start',
														}}
													>
														<input
															type='checkbox'
															style={{
																marginRight:
																	'1rem',
															}}
															disabled={disabled}
															{...register(
																'options_vehicule_leger',
																{
																	required: true,
																}
															)}
															value={
																'Frigorifique'
															}
															onChange={(e) => {
																const isChecked =
																	e.target
																		.checked
																const updatedOptions =
																	isChecked
																		? [
																				...optionsVehiculeLegerValue,
																				'Frigorifique',
																			]
																		: optionsVehiculeLegerValue.filter(
																				(
																					option
																				) =>
																					option !==
																					'Frigorifique'
																			)
																const bacheeIndex =
																	updatedOptions.indexOf(
																		'Bachée'
																	)
																if (
																	bacheeIndex !==
																	-1
																) {
																	updatedOptions.splice(
																		bacheeIndex,
																		1
																	)
																}
																setValue(
																	'options_vehicule_leger',
																	updatedOptions
																)
																handleOptionChange(
																	e
																)
															}}
														/>

														<span
															style={{
																marginRight:
																	'0.5rem',
															}}
														>
															{t("refrigerated")}
														</span>
													</div>
													{type_transport_details ===
														'Camion 20m³' && (
														<div
															style={{
																width: '15rem',
																display: 'flex',
																alignItems:
																	'center',
																justifyContent:
																	'flex-start',
															}}
														>
															<input
																type='checkbox'
																style={{
																	marginRight:
																		'1rem',
																}}
																disabled={
																	disabled
																}
																{...register(
																	'options_vehicule_leger',
																	{
																		required: true,
																	}
																)}
																value={'Bachée'}
																onChange={(
																	e
																) => {
																	const isChecked =
																		e.target
																			.checked
																	const updatedOptions =
																		isChecked
																			? [
																					...optionsVehiculeLegerValue,
																					'Bachée',
																				]
																			: optionsVehiculeLegerValue.filter(
																					(
																						option
																					) =>
																						option !==
																						'Bachée'
																				)
																	const frigorifiqueIndex =
																		updatedOptions.indexOf(
																			'Frigorifique'
																		)

																	if (
																		frigorifiqueIndex !==
																		-1
																	) {
																		updatedOptions.splice(
																			frigorifiqueIndex,
																			1
																		)
																	}
																	setValue(
																		'options_vehicule_leger',
																		updatedOptions
																	)
																	handleOptionChange(
																		e
																	)
																}}
															/>

															<span
																style={{
																	marginRight:
																		'0.5rem',
																}}
															>
																{t("tarped")}
															</span>
														</div>
													)}
													<div
														style={{
															width: '15rem',
															display: 'flex',
															alignItems:
																'center',
															justifyContent:
																'flex-start',
														}}
													>
														<input
															type='checkbox'
															style={{
																marginRight:
																	'1rem',
															}}
															disabled={disabled}
															{...register(
																'options_vehicule_leger',
																{
																	required: true,
																}
															)}
															value={'Tall'}
														/>

														<span
															style={{
																marginRight:
																	'0.5rem',
															}}
														>
															Tall
														</span>
													</div>

													<div
														style={{
															width: '15rem',
															display: 'flex',
															alignItems:
																'center',
															justifyContent:
																'flex-start',
														}}
													>
														<input
															type='checkbox'
															style={{
																marginRight:
																	'1rem',
															}}
															disabled={disabled}
															{...register(
																'options_vehicule_leger',
																{
																	required: true,
																}
															)}
															value={'Hayon'}
														/>

														<span
															style={{
																marginRight:
																	'0.5rem',
															}}
														>
															{t("liftgate")}
														</span>
													</div>
												</div>

												{type_transport.current ==
													null && <Seperator />}
											</div>
										</div>
									)}

									{type_transport.current !==
										'Véhicule léger' && (
										<div
											style={{
												display: 'flex',
												flexDirection: 'column',
												width: '100%',
											}}
										>
											<div style={{ width: '100%'}}>
												<div
													style={{
														display: 'flex',
														flexDirection: 'row',
														marginBottom: '1rem',
														
													}}
												>
													<div
														style={{
															display: 'flex',
															flexDirection: isMobile? 'column' : 'row',
															marginBottom:'1rem',
															width: '100%',
															gap : isMobile? '1rem' : 0
														}}
													>
														<div
															style={{
																display: 'flex',
																flexDirection:
																	'column',
																width: isMobile? '100%' : '48%',
																marginRight: isMobile? 0 : '2%',
															}}
														>
															<div
																style={{
																	width: '100%',
																	height: 'auto',
																	marginBottom: '0.5rem',
																}}
															>
																<img
																	src={
																		tonnes7
																	}
																	style={{
																		width: '100%',
																		height: 'auto',
																		maxWidth:
																			'120px',
																		maxHeight:
																			'80px',
																		objectFit:
																			'cover',
																	}}
																	alt=''
																/>
															</div>

															<div
																style={{
																	width: isMobile? '100%' : '50%',
																	display:
																		'flex',
																	alignItems:
																		'center',
																	justifyContent:
																		'flex-start',
																}}
															>
																<input
																	type='radio'
																	style={{
																		marginRight:
																			'1rem',
																	}}
																	disabled={
																		isV75TDisabled
																	}
																	{...register(
																		'vehicule_poids_lourds',
																		{
																			required: true,
																		}
																	)}
																	value='7,5 Tonnes'
																/>

																<span>
																	7,5 Tonnes
																</span>
															</div>
															<div
																style={{
																	marginLeft: 36,
																}}
															>
																<span
																	style={{
																		fontSize:
																			'14px',
																		marginRight:
																			'0.5rem',
																		fontWeight:
																			'bold',
																	}}
																>
																	2470 kg
																</span>
															</div>
															<div
																style={{
																	display:
																		'flex',
																	flexDirection:
																		'column',
																	background:
																		'#f2f3f4',
																	padding: 10,
																	width: isMobile? '100%' : '70%',
																	borderRadius:
																		'5px',
																	marginTop:
																		'10px',
																	fontSize:
																		'14px',
																	lineHeight:
																		'1.5',
																}}
															>
																<span>
																	{t("vehicle_detail1")} : 30m³{' '}
																</span>
																<span>
																	{t("vehicle_detail2")} :
																	6575mm{' '}
																</span>
																<span>
																	{t("vehicle_detail3")} :
																	2045mm{' '}
																</span>
																<span>
																	{t("vehicle_detail4")} :
																	2400mm{' '}
																</span>
																<span>
																	{t("vehicle_detail5")} :
																	2470kg{' '}
																</span>
																<span>
																	{t("vehicle_detail6")} : 16
																	pal europe
																</span>
															</div>
														</div>
														<div
															style={{
																display: 'flex',
																flexDirection:
																	'column',
																width: isMobile? '100%' : '48%',
																marginTop: -5,
															}}
														>
															<div
																style={{
																	width: '100%',
																	height: 'auto',
																	marginBottom:
																		'0.5rem',
																}}
															>
																<img
																	src={
																		tonnes12
																	}
																	style={{
																		width: '100%',
																		height: 'auto',
																		maxWidth:
																			'120px',
																		maxHeight:
																			'80px',
																		objectFit:
																			'cover',
																	}}
																	alt=''
																/>
															</div>

															<div
																style={{
																	width: isMobile? '100%' : '50%',
																	display:
																		'flex',
																	alignItems:
																		'center',
																	justifyContent:
																		'flex-start',
																}}
															>
																<input
																	type='radio'
																	style={{
																		marginRight:
																			'1rem',
																	}}
																	disabled={
																		is12TDisabled
																	}
																	{...register(
																		'vehicule_poids_lourds',
																		{
																			required: true,
																		}
																	)}
																	value='12 Tonnes'
																/>

																<span>
																	12 Tonnes
																</span>
															</div>
															<div
																style={{
																	marginLeft: 36,
																}}
															>
																<span
																	style={{
																		fontSize:
																			'14px',
																		marginRight:
																			'0.5rem',
																		fontWeight:
																			'bold',
																	}}
																>
																	5600 kg
																</span>
															</div>
															<div
																style={{
																	display:
																		'flex',
																	flexDirection:
																		'column',
																	background:
																		'#f2f3f4',
																	padding: 10,
																	width: isMobile? '100%' : '70%',
																	borderRadius:
																		'5px',
																	marginTop:
																		'10px',
																	fontSize:
																		'14px',
																	lineHeight:
																		'1.5',
																}}
															>
																<span>
																	{t("vehicle_detail1")} : 45m³{' '}
																</span>
																<span>
																	{t("vehicle_detail2")} :
																	7540mm{' '}
																</span>
																<span>
																	{t("vehicle_detail3")} :
																	2480mm{' '}
																</span>
																<span>
																	{t("vehicle_detail4")} :
																	2500mm{' '}
																</span>
																<span>
																	{t("vehicle_detail5")} :
																	5600kg{' '}
																</span>
																<span>
																	{t("vehicle_detail6")} : 19
																	pal europe
																</span>
															</div>
														</div>
													</div>
												</div>
											</div>
											<div style={{ width: '100%' }}>
												<div
													style={{
														display: 'flex',
														flexDirection: 'row',
													}}
												>
													<div
														style={{
															display: 'flex',
															flexDirection: isMobile? 'column' : 'row',
															marginBottom:'1rem',
															width: '100%',
														}}
													>
														<div
															style={{
																display: 'flex',
																flexDirection:
																	'column',
																width: isMobile? '100%' : '48%',
																marginRight: isMobile? 0 : '2%',
															}}
														>
															<div
																style={{
																	width: '100%',
																	height: 'auto',
																	marginBottom:
																		'0.5rem',
																}}
															>
																<img
																	src={
																		tonnes19
																	}
																	style={{
																		width: '100%',
																		height: 'auto',
																		maxWidth:
																			'120px',
																		maxHeight:
																			'80px',
																		objectFit:
																			'cover',
																	}}
																	alt=''
																/>
															</div>

															<div
																style={{
																	width: isMobile? '100%' : '50%',
																	display:
																		'flex',
																	alignItems:
																		'center',
																	justifyContent:
																		'flex-start',
																}}
															>
																<input
																	type='radio'
																	style={{
																		marginRight:
																			'1rem',
																	}}
																	disabled={
																		is19TDisabled
																	}
																	{...register(
																		'vehicule_poids_lourds',
																		{
																			required: true,
																		}
																	)}
																	value='19 Tonnes'
																/>

																<span>
																	19 Tonnes
																</span>
															</div>
															<div
																style={{
																	marginLeft: 36,
																}}
															>
																<span
																	style={{
																		fontSize:
																			'14px',
																		marginRight:
																			'0.5rem',
																		fontWeight:
																			'bold',
																	}}
																>
																	9200 kg
																</span>
															</div>
															<div
																style={{
																	display:
																		'flex',
																	flexDirection:
																		'column',
																	background:
																		'#f2f3f4',
																	padding: 10,
																	width: isMobile? '100%' : '70%',
																	borderRadius:
																		'5px',
																	marginTop:
																		'10px',
																	fontSize:
																		'14px',
																	lineHeight:
																		'1.5',
																}}
															>
																<span>
																	{t("vehicle_detail1")} : 58m³{' '}
																</span>
																<span>
																	{t("vehicle_detail2")} :
																	9100mm{' '}
																</span>
																<span>
																	{t("vehicle_detail3")} :
																	2470mm{' '}
																</span>
																<span>
																	{t("vehicle_detail4")} :
																	2490mm{' '}
																</span>
																<span>
																	{t("vehicle_detail5")} :
																	9200kg{' '}
																</span>
																<span>
																	{t("vehicle_detail6")} : 22
																	pal europe
																</span>
															</div>
														</div>

														<div
															style={{
																display: 'flex',
																flexDirection:
																	'column',
																width: isMobile? '100%' : '48%',
																marginRight: isMobile? '100%' : '2%',
															}}
														>
															<div
																style={{
																	width: '100%',
																	height: 'auto',
																	marginBottom:
																		'0.5rem',
																}}
															>
																<img
																	src={Semi}
																	style={{
																		width: '100%',
																		height: 'auto',
																		maxWidth:
																			'120px',
																		maxHeight:
																			'80px',
																		objectFit:
																			'cover',
																	}}
																	alt=''
																/>
															</div>

															<div
																style={{
																	width: isMobile? '100%' : '50%',
																	display:
																		'flex',
																	alignItems:
																		'center',
																	justifyContent:
																		'flex-start',
																	marginTop:
																		'1.2rem',
																}}
															>
																<input
																	type='radio'
																	style={{
																		marginRight:
																			'1rem',
																	}}
																	disabled={
																		isTracteurSemiDisabled
																	}
																	{...register(
																		'vehicule_poids_lourds',
																		{
																			required: true,
																		}
																	)}
																	value='Tracteur+semi'
																/>

																<span>
																	{t("tractor_semi" )}
																</span>
															</div>

															<div
																style={{
																	display:
																		'flex',
																	flexDirection:
																		'column',
																	background:
																		'#f2f3f4',
																	padding: 10,
																	width: isMobile? '100%' : '70%',
																	borderRadius:
																		'5px',
																	marginTop:
																		'10px',
																	fontSize:
																		'14px',
																	lineHeight:
																		'1.5',
																}}
															>
																<span>
																	{t("vehicle_detail2")} : 2.45
																	M
																</span>
																<span>
																	{t("vehicle_detail3")} : 1.50
																	M
																</span>
																<span>
																	{t("vehicle_detail4")} : 1.60
																	M
																</span>
																<span>
																	{t("vehicle_detail7")}
																	: 6 m³
																</span>
																<span>
																	{t("vehicle_detail8")} :
																	1000 kg
																</span>
																<span>
																	{t("vehicle_detail6")}: 32
																	pal europe
																</span>
															</div>
														</div>
													</div>
												</div>
											</div>

											<div style={{ width: '100%' }}>
												<div
													style={{
														display: 'flex',
														flexDirection: 'row',
														marginBottom: '1rem',
													}}
												>
													<div
														style={{
															display: 'flex',
															flexDirection: isMobile? 'column' : 'row',
															marginBottom:'1rem',
															width: '100%',
														}}
													>
														<div
															style={{
																display: 'flex',
																flexDirection:
																	'column',
																width: isMobile? '100%' : '48%',
																marginRight: isMobile? 0 : '2%',
															}}
														>
															<div
																style={{
																	width: '100%',
																	height: 'auto',
																	marginBottom:
																		'0.5rem',
																}}
															>
																<img
																	src={
																		tracteurSemi
																	}
																	style={{
																		width: '100%',
																		height: 'auto',
																		maxWidth:
																			'120px',
																		maxHeight:
																			'80px',
																		objectFit:
																			'cover',
																	}}
																	alt=''
																/>
															</div>

															<div
																style={{
																	width: isMobile? '100%' : '50%',
																	display:
																		'flex',
																	alignItems:
																		'center',
																	justifyContent:
																		'flex-start',
																}}
															>
																<input
																	type='radio'
																	style={{
																		marginRight:
																			'1rem',
																	}}
																	disabled={
																		disabled
																	}
																	{...register(
																		'vehicule_poids_lourds',
																		{
																			required: true,
																		}
																	)}
																	value='Tracteur'
																/>

																<span>
																	{t("tractor")}
																</span>
															</div>

															<div
																style={{
																	display:
																		'flex',
																	flexDirection:
																		'column',
																	background:
																		'#f2f3f4',
																	padding: 10,
																	width: isMobile? '100%' : '70%',
																	borderRadius:
																		'5px',
																	marginTop:
																		'10px',
																	fontSize:
																		'14px',
																	lineHeight:
																		'1.5',
																}}
															>
																<div
																	style={{
																		display:
																			'flex',
																		alignItems:
																			'center',
																		justifyContent:
																			'flex-start',
																	}}
																>
																	<span>
																		{t("vehicle_detail2")} :{' '}
																	</span>
																	<span>
																		2.45 M
																	</span>
																</div>
																<div
																	style={{
																		display:
																			'flex',
																		alignItems:
																			'center',
																		justifyContent:
																			'flex-start',
																	}}
																>
																	<span>
																		{t("vehicle_detail3")} :{' '}
																	</span>
																	<span>
																		1.50 M
																	</span>
																</div>
																<div
																	style={{
																		display:
																			'flex',
																		alignItems:
																			'center',
																		justifyContent:
																			'flex-start',
																	}}
																>
																	<span>
																		{t("vehicle_detail4")} :{' '}
																	</span>
																	<span>
																		1.60 M
																	</span>
																</div>
																<div
																	style={{
																		display:
																			'flex',
																		alignItems:
																			'center',
																		justifyContent:
																			'flex-start',
																	}}
																>
																	<span>
																		{t("vehicle_detail7")} :{' '}
																	</span>
																	<span>
																		6 m³
																	</span>
																</div>
															
															</div>
														</div>
													</div>
												</div>
											</div>

											<div
												style={{
													display: 'flex',
													flexDirection: 'column',
												}}
											>
												<span
													style={{
														marginBottom: '1rem',
														color: 'black',
														fontSize: 14,
													}}
												>
													{t("heavy_truck_options")}
												</span>
												{/* <div
											style={{
												display: 'flex',
												flexDirection: 'column',
											}}
										>
											<div
												style={{
													display: 'flex',
													flexDirection: 'row',
													//marginBottom: '1rem',
												}}
											>
												{[
													'Frigorifique',
													'Bachée',
													'Tall',
													'Hayon',
												].map((item, index) => (
													<div
														key={String(index)}
														style={{
															width: '15rem',
															display: 'flex',
															alignItems:
																'center',
															justifyContent:
																'flex-start',
														}}
													>
														<input
															type='checkbox'
															style={{
																marginRight:
																	'1rem',
															}}
															disabled={disabled}
															{...register(
																'options_poids_lourds'
															)}
															value={item}
														/>

														<span>{item}</span>
													</div>
												))}
											</div>
										</div> */}
												<div
													style={{
														display: 'flex',
														flexDirection: 'column',
														marginBottom: '1rem',
													}}
												>
													<div
														style={{
															display: 'flex',
															flexDirection:
																isMobile? 'column' : 'row',
															marginBottom:
																'1rem',
																gap : isMobile ? '1rem' : 0
														}}
													>
														<div
															style={{
																width: '15rem',
																display: 'flex',
																alignItems:
																	'center',
																justifyContent:
																	'flex-start',
															}}
														>
															<input
																type='checkbox'
																style={{
																	marginRight:
																		'1rem',
																}}
																disabled={
																	disabled
																}
																{...register(
																	'options_poids_lourds',
																	{
																		required: true,
																	}
																)}
																value={
																	'Frigorifique'
																}
																onChange={(
																	e
																) => {
																	const isChecked =
																		e.target
																			.checked
																	const updatedOptions =
																		isChecked
																			? [
																					...optionsPoidsLourdsValue,
																					'Frigorifique',
																				]
																			: optionsPoidsLourdsValue?.filter(
																					(
																						option
																					) =>
																						option !==
																						'Frigorifique'
																				)
																	const bacheeIndex =
																		updatedOptions.indexOf(
																			'Bachée'
																		)
																	if (
																		bacheeIndex !==
																		-1
																	) {
																		updatedOptions.splice(
																			bacheeIndex,
																			1
																		)
																	}
																	setValue(
																		'options_poids_lourds',
																		updatedOptions
																	)
																	handleOptionChange(
																		e
																	)
																}}
															/>

															<span
																style={{
																	marginRight:
																		'0.5rem',
																}}
															>
																{t("refrigerated")}
															</span>
														</div>
														{options_poids_lourds !==
															'Tracteur' && (
															<div
																style={{
																	width: '15rem',
																	display:
																		'flex',
																	alignItems:
																		'center',
																	justifyContent:
																		'flex-start',
																}}
															>
																<input
																	type='checkbox'
																	style={{
																		marginRight:
																			'1rem',
																	}}
																	disabled={
																		disabled
																	}
																	{...register(
																		'options_poids_lourds',
																		{
																			required: true,
																		}
																	)}
																	value={
																		'Bachée'
																	}
																	onChange={(
																		e
																	) => {
																		const isChecked =
																			e
																				.target
																				.checked
																		const updatedOptions =
																			isChecked
																				? [
																						...optionsPoidsLourdsValue,
																						'Bachée',
																					]
																				: optionsPoidsLourdsValue.filter(
																						(
																							option
																						) =>
																							option !==
																							'Bachée'
																					)
																		const frigorifiqueIndex =
																			updatedOptions.indexOf(
																				'Frigorifique'
																			)

																		if (
																			frigorifiqueIndex !==
																			-1
																		) {
																			updatedOptions.splice(
																				frigorifiqueIndex,
																				1
																			)
																		}
																		setValue(
																			'options_poids_lourds',
																			updatedOptions
																		)
																		handleOptionChange(
																			e
																		)
																	}}
																/>

																<span
																	style={{
																		marginRight:
																			'0.5rem',
																	}}
																>
																	{t("tarped")}
																</span>
															</div>
														)}
														<div
															style={{
																width: '15rem',
																display: 'flex',
																alignItems:
																	'center',
																justifyContent:
																	'flex-start',
															}}
														>
															<input
																type='checkbox'
																style={{
																	marginRight:
																		'1rem',
																}}
																disabled={
																	disabled
																}
																{...register(
																	'options_poids_lourds',
																	{
																		required: true,
																	}
																)}
																value={'Tall'}
															/>

															<span
																style={{
																	marginRight:
																		'0.5rem',
																}}
															>
																Tall
															</span>
														</div>

														<div
															style={{
																width: '15rem',
																display: 'flex',
																alignItems:
																	'center',
																justifyContent:
																	'flex-start',
															}}
														>
															<input
																type='checkbox'
																style={{
																	marginRight:
																		'1rem',
																}}
																disabled={
																	disabled
																}
																{...register(
																	'options_poids_lourds',
																	{
																		//required: true,
																	}
																)}
																value={'Hayon'}
															/>

															<span
																style={{
																	marginRight:
																		'0.5rem',
																}}
															>
																{t("liftgate")}
															</span>
														</div>
													</div>
												</div>
											</div>
										</div>
									)}
								</>
							)}
							{errors.type_transport && (
								<div
									style={{
										color: 'red',
										marginTop: '0.5rem',
									}}
								>
									{t("transport_type_err")}
								</div>
							)}
							{errors.type_transport_details && (
								<div
									style={{
										color: 'red',
										marginTop: '0.5rem',
									}}
								>
									{t("transport_type_err2")}.
								</div>
							)}
							{errors.options_vehicule_leger && (
								<div
									style={{
										color: 'red',
										marginTop: '0.5rem',
									}}
								>
									{t("transport_type_err3")}
								</div>
							)}
						</FormSectionCard>
					</FormContentSection>

					<FormContentSection>
						<FormSectionTitle></FormSectionTitle>
						<FormSectionCard>
							<p
								style={{
									color: 'black',
									//fontWeight: 'bold',
								}}
							>
								{t("dangerous_materials")}
							</p>

						<div
						className='radio-btn-group-palettes'
						style={{
							display: 'flex',
							flexDirection: 'row',
							marginBottom: '2rem',
						}}
					>
						<div
							className='radio'
							style={{
								marginRight: '1rem',
							}}
						>
							<input
								id={`danger-oui`}
								type='radio'
								value={true}
								{...register(`danger`, {
									required: true,
								})}
							/>

							<label htmlFor={`danger-oui`}>{t("yes")}</label>
						</div>

						<div
							className='radio'
							style={{
								marginRight: '1rem',
							}}
						>
							<input
								id={`danger-non`}
								type='radio'
								value={false}
								{...register(`danger`, {
									required: true,
								})}
							/>

							<label htmlFor={`danger-non`}>{t("no")}</label>
						</div>
					</div>
							{errors.danger && (
								<div
									style={{
										color: 'red',
										marginTop: '0.5rem',
									}}
								>
									{t("dangerous_materials_err")}
								</div>
							)}
						</FormSectionCard>
					</FormContentSection>
				</>
			)}

			{step === 3 && (
				<div>
					<FormContentSection>
						<FormSectionTitle>
							{t("additional_equipment")}
						</FormSectionTitle>
						<FormSectionCard>
							<div
								style={{
									display: 'flex',
									flexDirection: 'column',
									//marginBottom: '2.5rem',
								}}
							>
								<span
									style={{
										marginBottom: '1rem',
										color: 'black',
										fontSize: 14,
									}}
								>
									{t("handling_equipment")}
								</span>

								<button
									type='button'
									style={{
										marginBottom: '1rem',
										border: 'none',
										alignSelf: 'flex-start',
										padding: '1rem 2rem',
										background: '#72c5ed',
										color: 'white',
										fontWeight: 'bold',
										cursor: 'pointer',
										borderRadius: 5,
										fontFamily: 'Montserrat',
									}}
									onClick={() =>
										setValue('manutention', manutentionItems.map(item => item.value))
									}
								>
									{t("all")}
								</button>

								<div
									style={{
										display: 'flex',
										flexWrap: 'wrap',
										flexDirection: isMobile? 'column' : 'row',
										marginBottom: '1rem',
										gap : isMobile? '1rem' : 0
						
									}}
								>
									{manutentionItems.map((item, index) => (
										<div
											key={String(index)}
											style={{
												width: isMobile ? '100%' : '33%',
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'flex-start',
												marginBottom: '1rem',
											}}
										>
											<input
												type='checkbox'
												style={{
													marginRight: '1rem',
												}}
												disabled={disabled}
												{...register('manutention', {
													required: true,
												})}
												value={item.value}
											/>

											<span>{item.label}</span>
										</div>
									))}
								</div>
								{errors.manutention && (
									<div
										style={{
											color: 'red',
											marginTop: '0.5rem',
											marginBottom: '0.5rem',
										}}
									>
										{t("handling_equipment_err")}
									</div>
								)}
							</div>

							<div
								style={{
									display: 'flex',
									flexDirection: 'column',
									marginBottom: '1rem',
								}}
							>
								<span
									style={{
										marginBottom: '1rem',
										color: 'black',
										fontSize: 14,
									}}
								>
									{t("ppe")}
								</span>

								<button
									type='button'
									style={{
										marginBottom: '1rem',
										border: 'none',
										alignSelf: 'flex-start',
										padding: '1rem 2rem',
										background: '#72c5ed',
										color: 'white',
										fontWeight: 'bold',
										cursor: 'pointer',
										borderRadius: 5,
										fontFamily: 'Montserrat',
									}}
									onClick={() =>
										setValue('epi', epiItems.map(item => item.value))
									}
								>
									{t("all")}
								</button>

								<div
									style={{
										display: 'flex',
										flexWrap: 'wrap',
										flexDirection: isMobile ? 'column' : 'row',
										gap : isMobile ? '1rem' : 0
									}}
								>
									{epiItems.map((item, index) => (
										<div
											key={String(index)}
											style={{
												width: isMobile? '100%' : '33%',
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'flex-start',
												marginBottom: '1rem',
											}}
										>
											<input
												type='checkbox'
												style={{
													marginRight: '1rem',
												}}
												disabled={disabled}
												{...register('epi', {
													required: true,
												})}
												value={item.value}
											/>

											<span>{item.label}</span>
										</div>
									))}
								</div>
								{errors.epi && (
									<div
										style={{
											color: 'red',
											marginTop: '0.5rem',
										}}
									>
										{t("ppe_err")}
									</div>
								)}
							</div>

							{(type_transport.current === 'Poids lourds' || showElectricPalletJack) && (
								<div
									style={{
										display: 'flex',
										flexDirection: 'column',
										//marginBottom: '2.5rem',
									}}
								>
									<span
										style={{
											marginBottom: '1rem',
											color: 'black',
											fontSize: 14,
										}}
									>
										{t("handling_eq3")}
									</span>
									<div
										style={{
											display: 'flex',
											flexWrap: 'wrap',
											flexDirection: 'row',
											//marginBottom: '1rem',
										}}
									>
										<div
											style={{
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'flex-start',
												marginBottom: '1rem',
											}}
										>
											<input
												type='checkbox'
												style={{
													marginRight: '1rem',
												}}
												disabled={disabled}
												{...register(
													'transpalette_électrique',
													{}
												)}
												onChange={(e) => {
													setValue(
														'transpalette_électrique',
														e.target.checked
													)
												}}
											/>

											<span>{t("handling_eq3")}</span>
										</div>
									</div>
								</div>
							)}
						</FormSectionCard>
					</FormContentSection>

					{!hideSubmit && (
						<>
							<div
								style={{
									width: '100%',
									margin: '2rem 0',
								}}
							>
								<div
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center',
										//marginBottom: '1rem',
									}}
								>
									<input
										type='checkbox'
										style={{
											marginRight: '1rem',
										}}
										{...register('accept', {
											required: true,
										})}
										value={'accept'}
									/>

									<label
									 htmlFor="accept"
									 style={{
									  fontSize: '15px',
									  color: '#111827',
									  cursor: 'pointer',
									  userSelect: 'none',
									  lineHeight: '1.4',
									}}
									>
									{t("accept_terms_and_conditions")}{' '}
								 <Link
								  to="/cgv"
								  target="_blank"
								  style={{
								  color: '#5EBCEA',
								  fontWeight: 600,
								  textDecoration: 'underline',
								  }}
								>
								 {t("terms_and_conditions")}
								</Link>
								</label>
								</div>
							</div>

							{user?.premium && (
								<div
									style={{
										width: '100%',
										textAlign: 'center',
										marginTop: '1rem',
									}}
								>
									<span
										style={{
											fontSize: 13,
										}}
									>
										{t("premium_client1")}{' '}
										<span
											style={{
												color: '#f1e5b0',
												fontWeight: 'bold',
											}}
										>
											{t("premium_client2")}
										</span>{' '}
										{t("premium_offer1")}
									</span>
								</div>
							)}
							{!!user?.reduction && (
								<div
									style={{
										width: '100%',
										textAlign: 'center',
										marginTop: '1rem',
									}}
								>
									<span
										style={{
											width: '6rem',
											fontSize: 13,
											marginTop: '1rem',
										}}
									>
										{t("premium_offer2")}{' '}
										{user.reduction}%.
									</span>
								</div>
							)}
							<SubmitButtonContainer>
								<SubmitButton type='submit' disabled={loading}>
									{loading ? t("loading") : submitButtonText}
								</SubmitButton>
							</SubmitButtonContainer>
						</>
					)}
					<button
						onClick={(e) => handlePrevious(e)}
						style={{
							marginBottom: '1rem',
							border: 'none',
							alignSelf: 'flex-start',
							padding: '1rem 2rem',
							background: '#72c5ed',
							color: 'white',
							fontWeight: 'bold',
							cursor: 'pointer',
							borderRadius: 5,
							width:isMobile? '50%' :'20%',
							fontFamily: 'Montserrat',
							marginRight: '1rem',
							marginTop: '3rem',
						}}
					>
						{t("previous")}
					</button>
				</div>
			)}
			<div
				style={{
					marginTop: '1rem',
					display: 'flex',
					flexDirection: 'row',
				}}
			>
				{step < 0 && (
					<button
						onClick={(e) => handlePrevious(e)}
						type='button'
						style={{
							marginBottom: '1rem',
							border: 'none',
							alignSelf: 'flex-start',
							padding: '1rem 2rem',
							background: '#72c5ed',
							color: 'white',
							fontWeight: 'bold',
							cursor: 'pointer',
							borderRadius: 5,
							width:isMobile? '50%' : '20%',
							fontFamily: 'Montserrat',
							marginRight: '1rem',
						}}
					>
						{t("previous")}
					</button>
				)}
				{step < 0 && step < 0 && (
					<button
						style={{
							marginBottom: '1rem',
							border: 'none',
							alignSelf: 'flex-start',
							padding: '1rem 2rem',
							background: '#72c5ed',
							color: 'white',
							fontWeight: 'bold',
							cursor: 'pointer',
							borderRadius: 5,
							fontFamily: 'Montserrat',
							width: isMobile? '50%' :'20%',
							marginRight: '1rem',
						}}
						type='button'
						onClick={(e) => handleNext(e)}
					>
						{t("next")}
					</button>
				)}
			</div>
		</StyledForm>
	)
}

export default React.memo(CommandeForm)
